import React from 'react';
import PropTypes from 'prop-types';
import LikeButtonContainer from './LikeButtonContainer';
import ShareButtonDropdownMenu from './ShareButtonDropdownMenu';

export default function SecondaryButtonContainer({ design }) {
    return (
        <div className="button-group button-group--giant">
            <div className="button-group__item">
                <LikeButtonContainer design={design} />
            </div>
            <div className="button-group__item">
                <ShareButtonDropdownMenu design={design} />
            </div>
        </div>
    );
}

SecondaryButtonContainer.propTypes = {
    design: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};



// WEBPACK FOOTER //
// ./src/js/apps/designdetails/components/SecondaryButtonContainer.jsx